module.exports = __webpack_public_path__ + "img/title-category.6185d990.svg";